import { ByteArrayContractParameter } from '@neo-one/node-core';
import { StackItemBase } from './StackItemBase';
export class BufferStackItem extends StackItemBase {
    constructor(value) {
        super();
        this.value = value;
    }
    asBuffer() {
        return this.value;
    }
    toContractParameter(_seen = new Set()) {
        return new ByteArrayContractParameter(this.value);
    }
}

//# sourceMappingURL=BufferStackItem.js.map
